import React from 'react'

const Dashboard = () => {
  return (
    <div>
      SO this is my dashboard
    </div>
  )
}

export default Dashboard
